import {
    Modal,
} from "@mrflark/ui";

import type {
    ShortcutContext,
} from "../../shortcuts/definitions.ts";
import {
    getShortcutSections,
} from "../../shortcuts/definitions.ts";

type KeyboardShortcutsModalProps = {
    isOpen: boolean;
    onClose: () => void;
    context?: ShortcutContext;
};

export const KeyboardShortcutsModal = ({
    isOpen,
    onClose,
    context = "viewer",
}: KeyboardShortcutsModalProps) => {
    const sections = getShortcutSections(context);

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Keyboard Shortcuts"
            size="md"
        >
            <div className="space-y-6">
                {sections.map((section) => (
                    <div key={section.title}>
                        <h3 className="text-sm font-semibold text-text-secondary uppercase tracking-wider mb-3">
                            {section.title}
                        </h3>
                        <div className="space-y-2">
                            {section.shortcuts.map((shortcut, index) => (
                                <div
                                    key={index}
                                    className="flex items-center justify-between"
                                >
                                    <div className="flex items-center gap-1">
                                        {shortcut.keys.map((key, keyIndex) => (
                                            <span
                                                key={keyIndex}
                                                className="flex items-center gap-1"
                                            >
                                                {keyIndex > 0 && (
                                                    <span className="text-text-muted">
                                                        /
                                                    </span>
                                                )}
                                                <kbd className="px-2 py-1 text-xs font-mono bg-bg-tertiary border border-border rounded text-text-primary">
                                                    {key}
                                                </kbd>
                                            </span>
                                        ))}
                                    </div>
                                    <span className="text-sm text-text-secondary">
                                        {shortcut.description}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </Modal>
    );
};
